import { ColorAA } from "../constants";
import BreakdownBar from "./BreakdownBar";

export const RequestUsageBar = ({
  used,
  max,
  unit = "request",
  backgroundColor,
  borderColor,
}: {
  used: number;
  max: number;
  unit?: string;
  backgroundColor?: string;
  borderColor?: string;
}) => {
  const remaining = max - used;
  const label = (count: number, suffix: string) =>
    `${Intl.NumberFormat().format(count)} ${count === 1 ? unit : `${unit}s`} ${suffix}`;

  return remaining >= 0 ? (
    <BreakdownBar
      segments={[
        {
          size: used,
          tooltip: label(used, "used"),
          borderColor: borderColor,
          fillColor: backgroundColor,
        },
        {
          size: remaining,
          tooltip: label(remaining, "remaining"),
          borderColor: ColorAA.lightGrey,
          fillColor: ColorAA.lightGrey,
        },
      ]}
    />
  ) : (
    <BreakdownBar
      segments={[
        {
          size: max,
          tooltip: label(max, "max"),
          borderColor: ColorAA.pink,
          fillColor: ColorAA.pink,
        },
        {
          size: used - max,
          tooltip: label(used - max, "above limit"),
          borderColor: ColorAA.pink,
          fillColor: ColorAA.pink,
          stripePattern: true,
        },
      ]}
    />
  );
};
